import isMobile from '../../plugins/is-mobile.js';

if (!(isMobile(768))) {
  $('body').addClass('is-width-pc');
} else {
  $('body').addClass('is-width-sp');
}
